import React from "react";
import { connect } from "react-redux";
import { broadcastAnd, addChat, setRoom } from "../redux/actions";
import { faEject, faPlay, faPause, faForward, faBackward } from "@fortawesome/free-solid-svg-icons";

import IconButton from "./IconButton";
import FixedClock from "../lib/FixedClock";

const PureRoomControls = (props) => {

    const getUserInfo = () => ({
        nick_name: props.nick_name,
        room_key: props.room_key
    });

    const getFullRoomDetails = () => ({
        is_playing: props.is_playing,
        video_url: props.video_url,
        subtitle_url: props.subtitle_url,
        video_position: props.ideal_position,
        video_position_timestamp: FixedClock.utc(),
        video_length: props.video_length,
        password: props.password
    });

    const sendChat = (msg) => {
        props.broadcastAnd({
            ...getUserInfo(),
            namespace: "chat",
            action: addChat(props.nick_name, msg)
        });
    };

    const changeRoom = (changes,msg) => {
        const newState = { ...getFullRoomDetails(),...changes };
        props.broadcastAnd({
            ...getUserInfo(),
            namespace: "control",
            action: setRoom(newState)
        });
        sendChat(msg);
    };


    const handlePlay = () => {changeRoom({ is_playing: true },"[Hit play at position " + parseInt(props.ideal_position) + "s]");};
    const handlePause = () => { changeRoom({ is_playing: false },"[Hit pause at position " + parseInt(props.ideal_position) + "s]");};
    const handleEject = () => { changeRoom({ video_url: "", subtitle_url: "", video_position: 0, video_length: 0 },"[Hit eject]");};
    const handleSkipForward = () => { changeRoom({ video_position: props.ideal_position + 30 },"[Hit forward]");};
    const handleSkipBack = () => { changeRoom({ video_position: props.ideal_position - 30 },"[Hit back]");};

    return (
        <>
            <IconButton title="Load a movie URL (for everyone)" key="eject" icon={faEject} onClick={handleEject}>Eject</IconButton>
            <IconButton title="Play (for everyone)" key="play" icon={faPlay} highlighted={props.is_playing} onClick={handlePlay}>Play</IconButton>
            <IconButton title="Pause (for everyone)" key="pause" icon={faPause} highlighted={!props.is_playing} onClick={handlePause}>Pause</IconButton>
            <IconButton title="Skip backwards 30s (for everyone)" key="backward" icon={faBackward} onClick={handleSkipBack}>Back</IconButton>
            <IconButton title="Skip forwards 30s (for everyone)" key="forward" icon={faForward} onClick={handleSkipForward}>Forward</IconButton>
        </>
    );
};

const mapStateToProps = state => ({ 
    password: state.room.password, 
    nick_name: state.user.nick_name, 
    room_key: state.user.room_key, 
    view_mode: state.user.view_mode,
    video_length: state.room.video_length,
    ideal_position: state.user.ideal_position,
    video_position: state.room.video_position,
    room_password: state.user.room_password,
    is_playing: state.room.is_playing,
    video_url: state.room.video_url,
    subtitle_url: state.room.subtitle_url

});

export const RoomControls = connect(mapStateToProps, { broadcastAnd })(PureRoomControls);